import { createModel } from "nyax";
import { Robot, RobotQuery } from "src/models/robot";
import { RobotEntityModel } from "src/store/models/entity/robot/entity";
import { RobotSideUIModel } from "src/store/models/ui/robot/robotSide";
import { createUITableWithPermissionModel } from "src/store/models/ui/_shared";

export const RobotTableUIModel = createModel(
  class extends createUITableWithPermissionModel<Robot, RobotQuery>({
    setItems: (getContainer, items) =>
      getContainer(RobotEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(RobotEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(RobotEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      const superEffects = super.effects();
      return {
        ...superEffects,
        updateQuery: async (params: RobotQuery) => {
          await superEffects.updateQuery(params);
          await this.getContainer(RobotSideUIModel).actions.setQuery.dispatch(
            this.state.query
          );
        },
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: RobotQuery
            ) => {
              return this.dependencies.serviceClient.robot.list(
                departmentId,
                pageIndex,
                pageSize,
                query
              );
            },
          });
        },
      };
    }
  }
);
